import VerdantProvider from '@/components/VerdantProvider.jsx';
import NiceModal, { useModal } from '@ebay/nice-modal-react';
import { Button } from '@heroui/react';

import { useMemoizedFn, useUpdateEffect } from 'ahooks';
import { memo, type ReactNode } from 'react';
import isEqual from 'react-fast-compare';
import { ModalProvider } from 'react-modal-hook';
import { Sheet } from 'react-modal-sheet';

const SheetWrapper = memo(
  ({ children, closeKey }: { children: ReactNode; closeKey: number }) => {
    const modal = useModal();
    const handleClose = useMemoizedFn(() => {
      modal.hide();
      setTimeout(() => {
        modal.remove();
      }, 300);
    });
    useUpdateEffect(() => {
      handleClose();
    }, [closeKey]);

    return (
      <VerdantProvider>
        <ModalProvider>
          <Sheet
            isOpen={modal.visible}
            onClose={handleClose}
            detent='content-height'
            disableScrollLocking
            style={{ zIndex: 50 }}
          >
            <Sheet.Container className='!rounded-t-3xl  '>
              <Sheet.Header />
              <Sheet.Content className='pb-safe'>{children}</Sheet.Content>
            </Sheet.Container>
            <Sheet.Backdrop className='!bg-black/55' onTap={handleClose} />
          </Sheet>
        </ModalProvider>
      </VerdantProvider>
    );
  },
  isEqual
);

export const SheetWrapperHeader = memo(
  ({
    title,
    onOk,
    hideOk,
    align,
    extra,
    okText,
    sticky,
  }: {
    title: string;
    onOk?: () => void;
    align?: string;
    hideOk?: boolean;
    extra?: ReactNode;
    okText?: string;
    sticky?: boolean;
  }) => {
    return (
      <header
        className={`flex items-center bg-white   px-4 relative font-semibold text-gray-800  ${
          align === 'left' ? 'text-2xl' : 'text-center text-lg justify-center'
        } ${sticky ? ' sticky top-0' : ''}`}
      >
        {title}
        <div className='absolute right-4'>
          {!hideOk && (
            <Button
              className='  font-bold'
              size='sm'
              radius='full'
              color='primary'
              type='submit'
              onPress={onOk}
            >
              {okText || '完成'}
            </Button>
          )}
          {extra}
        </div>
      </header>
    );
  },
  isEqual
);
export default SheetWrapper;
